module.exports = __webpack_public_path__ + "img/_customer_notes.1d23c0dc.svg";